// @flow
import React from 'react'

const Loader = () => <div>LOADER</div>

export default Loader
